
import {getDoc,startAfter,endAt,onSnapshot,startAt,endBefore,query,Unsubscribe,QueryDocumentSnapshot,orderBy} from "firebase/firestore"
import { Component, Mixins, Watch  } from "vue-property-decorator";
import ModalEditEvent from "@/components/ModalEditEvent.vue";
import ModalEventDetails from "@/components/ModalStaffEventDetails.vue";
import ModalEventHistory from "@/components/ModalEventHistory.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import ModalAlert from "@/components/ModalAlert.vue";
import ModalAddClass from "@/components/ModalAddClass.vue";
import Common from '@/mixins/common';
import FullCalendar from '@fullcalendar/vue'
import {CalendarOptions, DateSelectArg, EventClickArg, DatesSetArg,EventDropArg, EventInput} from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction'
import luxon2Plugin from '@fullcalendar/luxon2'
import jaLocale from '@fullcalendar/core/locales/ja';
import {toHiragana,toZen} from 'jaconv'
import { httpsCallable } from "firebase/functions";
import { functions } from "@/scripts/firebase";
import { GetCalendarArg, GetCalendarRes, EventData, EventExtendedProps} from "@/common-datatypes"
import TemplateMembers from "@/components/TemplateMembers.vue"
import { DateTime } from "luxon";

type Taxonomy = {
	[key in 'class' | 'group'|'type'|'status'|'postStatus']: Term[]
};

interface Term {
  name: string;
  id: string;
  count: number;
}

interface SelectedFilter {
  class: Term | null;
  group: Term | null;
  type: Term | null;
  status: Term | null;
  postStatus: Term | null;
  searchText: string;
}

@Component({
  components: {
    ModalEditEvent,
    ModalEventDetails,
    ModalEventHistory,
    ModalConfirm,
    ModalAlert,
    FullCalendar,
    TemplateMembers,
    ModalAddClass
  }
})

export default class Scheduler extends Mixins(Common) {
  eventsObservers: Unsubscribe[] = []

  taxonomy: Taxonomy = {
    class: [],
    group: [],
    type: [],
    status: [],
    postStatus: [],
  }

  selectedFilter: SelectedFilter = {
    class: null,
    group: null,
    type: null,
    status: null,
    postStatus: null,
    searchText: '' 
  }

  showModalEditEvent = false
  showModalCopyEvent = false
  showModalEventDetails = false
  showModalEventHistory = false
  showModalAlert = false
//コピーしますか?
// postStatus is draft
// コントロールキーを押しながら
  confirmCopyEvent = {title: '', message: ''}

  alert = {title: '', message: ''}

  
  timeZone = ''
  defaultTheEventData: EventData = {
    title: '',
    timeZone: this.timeZone,
    start: DateTime.now().startOf('hour').toJSDate(),
    end: DateTime.now().startOf('hour').plus({hour: 1}).startOf('hour').toJSDate(),
    extendedProps: {
      note: '',
      type: 'lesson',
      className: '',
      classId: '',
      classRef: undefined,
      teacherUserIds: [],
      studentUserIds: [],
      groupName: '',
      groupId: '',
      groupRef: undefined,
      hostUserIds: [],
      guestUserIds: [],
      memberUserIds: [],
      memberMeta: {},
      status: 'fixed',
      postStatus: 'publish',
      author: '',
      schoolId: '',
      docId: undefined,
      updateTime: undefined,
      creationTime: undefined
    }
  }

  theEventData = {...this.defaultTheEventData}

  modalEventProps = {
    isLoading: false,
    errorMessage: '',
    confirmText: 'event.add',
    theEventData: this.theEventData
  }

  rawEvents: EventData[] = []
  currentEvents: EventData[] = []

  iCalEvents = [] as EventInput[]

  get calendarApi(){
    return (this.$refs.fullCalendar as InstanceType<typeof FullCalendar>).getApi()
  }

  calendarOptions: CalendarOptions = {
    plugins:  [listPlugin ,luxon2Plugin, timeGridPlugin, dayGridPlugin, interactionPlugin ] ,
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonthCustom'
    },
    views: {
      listMonthCustom: {
        type: 'listMonth',
        duration: { days: 365},
        titleFormat: () => {
          return this.$t('schedule.list') as string
        }
      }
    },
    eventClassNames: (content) => {
      const classNames = []
      const exProps = content.event.extendedProps

      if(! exProps.docId){
        classNames.push('fc-event-imported')
      }

      if(exProps.status){
        classNames.push('fc-event-status-' + exProps.status)
      }
      if(exProps.postStatus){
        classNames.push('fc-event-poststatus-' + exProps.postStatus)
      }
      return classNames
    },
     aspectRatio: (() => {
      return window.innerWidth / window.innerHeight
    })(),
    windowResize: (arg) => {
      arg.view.calendar.setOption('aspectRatio', window.innerWidth / window.innerHeight)
    },
    windowResizeDelay: 300,
    dayMaxEvents: true,
    eventMaxStack: 3,
    firstDay: 1,//Monday
    navLinks: true,
    selectable: true,
    initialView: 'dayGridMonth',
    locales: [jaLocale],
    timeZone: undefined,
    locale: this.lang,
    //dateClick: this.handleDateClick,
    eventClick: this.handleEventClick,
    select: this.handleEventSelect,
    eventTimeFormat: { hour12: false, hour: '2-digit', minute: '2-digit', timeZoneName: undefined },//timeZoneName: 'short'
    eventStartEditable: false,
    eventDurationEditable: false,
    eventDrop: this.handleEventDrop,
    //eventDragStart: this.handleDragStart,
    datesSet: this.handleCalendarDatesSet,
    rerenderDelay: 0
    //eventsSet: this.handleEventsSet,
  //  viewClassNames: 'is-loading'
  }

  Loading = false

  theEventDocId = ''

  Timer: number | undefined

  get offset(){
    const timeZone = this.$timeZoneList.find((tz) => {return tz.name === this.timeZone})
    return timeZone ? timeZone.offset : ''
  }

  setEvents(){
    console.log('setEvents')
    this.calendarApi.batchRendering(() => {
      this.calendarApi.removeAllEvents()
      this.calendarApi.addEventSource(this.currentEvents)
      this.calendarApi.addEventSource(this.iCalEvents)
    })
  }

  @Watch('Loading')
  changeLoading(newval: boolean){
    console.log(newval)
    if(newval === false){
      this.setTaxonomies()
      this.setFilterOnEventsData(this.selectedFilter)
      this.setEvents()
      this.closeEditModalOnConflict()
    }
  }

  get updatedRawEvents(){
    console.log('updatedRawEvents')
    const time = Date.now()
    if(this.currentEvents.length !== this.rawEvents.length){
      console.log('length')
      return time
    }
    
    if(this.rawEvents.some((rEvent) => {
        return this.currentEvents.some((cEvent) => {
          return rEvent.id && (cEvent.id === rEvent.id) && rEvent.extendedProps.updateTime !== cEvent.extendedProps.updateTime})
       })){
        console.log('update')
      return time
    }

    if(this.rawEvents.some((rEvent) => {
        return this.currentEvents.every((cEvent) => {return cEvent.id !== rEvent.id})
       })){
        console.log('delele')
      return time
    }
    return 0
  }

  @Watch('updatedRawEvents',{immediate: true})
  changeUpdateRawEvents(updated: number){
    console.log(updated)
    if(updated === 0){
      return
    }
    this.Loading = true
    const delay = 800

    window.clearTimeout(this.Timer)
    this.Timer = window.setTimeout(() => {
      this.Loading = false
    }, delay)
    
  }

  handleCalendarDatesSet(arg: DatesSetArg){
    console.log('change DatesSet')

    const startDate = arg.view.activeStart
    const endDate = arg.view.activeEnd

    this.rawEvents = []
    this.setTaxonomies()
    this.$unsubscriber(this.eventsObservers)

    const setEventData = (doc: QueryDocumentSnapshot<EventData>) => {
      const event = doc.data()
      const findIndex = this.rawEvents.findIndex(rawEvent => {return event.id === rawEvent.id})
      event.timeZone = event.timeZone ? event.timeZone : this.timeZone 
     
      if(findIndex === -1){
        this.rawEvents.push(event)
      }else{
        this.rawEvents.splice(findIndex, 1, event)
      }
    }

    try{
      const eventsStartQuery = query(this.$getEventsColRef(),orderBy('start','asc'),startAt(startDate),endBefore(endDate))

      const observerStart = onSnapshot(eventsStartQuery,(snapshot) => {
        snapshot.docs.forEach((doc) => {
          setEventData(doc)
        })
      })

      this.eventsObservers.push(observerStart)

      const eventsEndQuery = query(this.$getEventsColRef(),orderBy('end','asc'),startAfter(startDate),endAt(endDate))

      const observerEnd = onSnapshot(eventsEndQuery,(snapshot) => {
        snapshot.docs.forEach((doc) => {setEventData(doc)})
      })

      this.eventsObservers.push(observerEnd)
      
    }catch(error){
      console.log(error)
    }
    
  }

  setFilterOnEventsData(filter: SelectedFilter){
    const searchText = toHiragana(toZen(filter.searchText))

    const settingFilter = !! (filter.class || filter.group || filter.type || filter.status || filter.postStatus || filter.searchText)

    const foundSearchText = (val: string, event: EventData) => {
      if(val === ''){
          return false
      }

      const memberMeta = event.extendedProps.memberMeta || {}

      if(Object.values(memberMeta).some((user)=>{return this.$findTextByUserProfile(val,user)})){
        return true
      }

      let targetText = (event.title || '') + (event.note || '') + (event.description || '')

      targetText = toHiragana(toZen(targetText))

      if(targetText.indexOf(val) > -1){
          return true
      }
      return false
    }

    this.iCalEvents = this.iCalEvents.map(event => {
      const description = event.extendedProps?.description || ''
      const title = event.title || ''

      let targetText = title + description

      targetText = toHiragana(toZen(targetText))

      event.display = 'none'

      if(! settingFilter){
        event.display = 'auto'
        return event
      }

      if(searchText && targetText.indexOf(searchText) > -1){
        event.display = 'auto'
        return event
      }

      return event
     
    })
  

    this.currentEvents = this.rawEvents.map(event => {
      //const groupId = event.extendedProps.groupId
      const groupName = event.extendedProps.groupName || null
      //const classId = event.extendedProps.classId
      const className = event.extendedProps.className || null
      const type = event.extendedProps.type || null
      const status = event.extendedProps.status || null
      const postStatus = event.extendedProps.postStatus || null

      event.display =  'auto'

      if(! settingFilter){
        if(postStatus == 'trash'){
          event.display =  'none'
         }
        return event
      }

      if(searchText && ! foundSearchText(searchText, event)){
        event.display = 'none'
        return event
      }

      if(filter.type && filter.type.name && filter.type.name !== type){
        event.display = 'none'
        return event
      }

      if(filter.status && filter.status.name && filter.status.name !== status){
        event.display = 'none'
        return event
      }

      if(filter.postStatus && filter.postStatus.name && filter.postStatus.name !== postStatus){
        event.display = 'none'
        return event
      }

      if(filter.group && filter.group.name && filter.group.name !== groupName){
        event.display = 'none'
        return event
      }

      if(filter.class && filter.class.name && filter.class.name !== className){
        event.display = 'none'
        return event
      }

      return event
    })

    
  }

 @Watch('selectedFilter',{deep: true})
 changeSelectedFilter(newVal: SelectedFilter){
  this.setFilterOnEventsData(newVal)
  this.setEvents()
 }

  setTaxonomies(){
    this.resetCountTaxonomy()
  
    this.rawEvents.forEach(event => {
      const classId = event.extendedProps.classId || null
      const className = event.extendedProps.className || null
      const groupId = event.extendedProps.groupId || null
      const groupName = event.extendedProps.groupName || null
      const status = event.extendedProps.status || null
      const type = event.extendedProps.type || null
      const postStatus = event.extendedProps.postStatus || null
      
      if(groupId && groupName){
        this.setTaxonomy(this.taxonomy.group ,groupName, groupId)
      }

      if(classId && className){
        this.setTaxonomy(this.taxonomy.class ,className, classId)
      }

      if(type){
        this.setTaxonomy(this.taxonomy.type,type)
      }

      if(status){
        this.setTaxonomy(this.taxonomy.status,status)
      }

      if(postStatus){
        this.setTaxonomy(this.taxonomy.postStatus,postStatus)
      }
    })
  }

  closeEditModalOnConflict(){
    //モーダル開いているイベントが編集されたときは警告表示して閉じる

    if((this.showModalEventDetails || this.showModalEditEvent) && this.modalEventProps.isLoading === false){
      const eventId = this.theEventData.id
      const updateTime = this.theEventData.extendedProps.updateTime
      if(eventId !== '' && updateTime){
        const findIndex = this.currentEvents.findIndex((event) => {
          if(event.id === eventId && event.extendedProps.updateTime){
            const nowUpdateTimeDt = DateTime.fromJSDate(event.extendedProps.updateTime)
            const updateTimeDt = DateTime.fromJSDate(updateTime)
            if(nowUpdateTimeDt > updateTimeDt){
              return true
            }
          }
          return false
        })
        
        if(findIndex > -1){
          this.showModalAlert = true
          this.showModalEditEvent = false
          this.showModalEventDetails = false
          this.alert = {
            title: this.$t('event.updatedEvent') as string,
            message: this.$t('event.updatedByOtherUser') as string
          }
        }
      }
    }
  }

  resetCountTaxonomy(){
    Object.keys(this.taxonomy).forEach((type) => {
      const t = type as keyof Taxonomy
      this.taxonomy[t] = this.taxonomy[t].map((term) => {
        term.count = 0
        return term
      })
    })
  }

  setTaxonomy(type: Term[], name: string, id = ''){
    if(! name){
      return
    }

    const findIndex = type.findIndex((term) => {
      if(id !== ''){
        return term.id === id && term.name === name
      }
      return term.name === name
    })

    const term: Term = {
      name: name,
      count: 1,
      id: id
    }

    if(findIndex === -1){
      type.push(term)
    }else{
      term.count = 1 + type[findIndex].count
      type.splice(findIndex, 1,term)
    }
  }

/*
  handleDateClick(arg: DateClickArg) {
    console.log('dateClick')
    this.openModalAddEvent(arg)
  }
*/
  handleEventClick(arg: EventClickArg): void {
    if(arg.event.id && arg.jsEvent.ctrlKey === true && arg.view.type.indexOf('list') === -1){//selected
      this.currentEvents = this.currentEvents.map((event) => {
        if(event.id === arg.event.id){
          event.borderColor = event.borderColor ? '' : '#000'
          event.groupId = event.groupId ? '' : 'selected'
          this.calendarApi.batchRendering(() => {
            arg.event.remove()
            this.calendarApi.addEvent(event)
          })
        }
        return event
      })
      return
    }

    this.theEventData.title = arg.event.title
    this.theEventData.timeZone = this.timeZone
    this.theEventData.start = arg.event.start || this.theEventData.start
    this.theEventData.end = arg.event.end || this.theEventData.end
    this.theEventData.extendedProps = arg.event.extendedProps as EventExtendedProps
    this.theEventData.id = arg.event.id
    this.showModalEventDetails = true
  }

  handleEventSelect(arg: DateSelectArg) {
    console.log('eventSelect')
    this.openModalAddEvent(arg)
  }

  copyEvents: EventData[] = []

  handleEventDrop(arg: EventDropArg){
    let events = [arg.event]
    //this.copyEvents.push(arg.event as )
    events = events.concat(arg.relatedEvents)
    events = events.filter((event) => {return event.extendedProps.docId})
    const eventTitles: string[] = []
    
    this.copyEvents = events.map((event) => {
      let originalTitle = event.title || ''

      let nextBranchNumber = 2

      const match = originalTitle.match(/^(.+)-(\d+)$/)

      if(match){
        nextBranchNumber = parseInt(match[2],10) + 1
        originalTitle = match[1]
      }

      let title = originalTitle + '-' + nextBranchNumber

      while(this.currentEvents.some((event)=>{return event.title === title}) || eventTitles.includes(title)){
        nextBranchNumber ++
        title = originalTitle + '-' + nextBranchNumber
      }

      eventTitles.push(title)

      const exProps = {
        ...event.extendedProps,
        docId: '',
      } as EventExtendedProps
      exProps.postStatus = 'draft'
      const data: EventData = {
        ...this.defaultTheEventData,
        id: '',
        title: title,
        extendedProps: exProps,
        start: event.start || this.defaultTheEventData.start,
        end: event.end || this.defaultTheEventData.end
      }
      return data
    })

    const num = this.copyEvents.length

    const titles = '<ul><li>' + this.copyEvents.map((event) => {return event.title}).join('</li><li>') + '</li></ul>'

    this.confirmCopyEvent = {
      title: this.$tc('event.copyEvents',num) as string,
      message: this.$tc('event.copyFollowingEvents',num) as string + titles,
    }

    this.showModalCopyEvent = true
  }

  @Watch('timeZone')
  changeTimezone(newVal: string){
    console.log('change timeZone')
    this.calendarOptions.timeZone =  newVal
    this.defaultTheEventData.timeZone = newVal
  }

  openModal(arg: {type: 'edit' | 'history'; eventId: string}){
    //console.log(arg)
    if(arg.type === 'edit'){
      this.showModalEventDetails = false
      this.showModalEditEvent = true
      this.modalEventProps.theEventData = this.theEventData
      this.modalEventProps.confirmText = 'event.edit'
    }else if(arg.type === 'history'){
      this.showModalEventDetails = false
      this.showModalEventHistory = true
    }
  }

  openModalAddEvent(data: DateSelectArg){
    //console.log(data)
    if(data.start && data.end){
      this.theEventData = {...this.defaultTheEventData}
      
      console.log('start end')
      
      this.theEventData.start = data.start
      this.theEventData.end = data.end
      if(data.allDay === true && data.view.type.indexOf('day') === 0){
        //dayGrid選択時は終日扱いにしない
        this.theEventData.start = DateTime.fromJSDate(data.start).setZone(this.theEventData.timeZone).plus({hours: 10}).toJSDate()
        this.theEventData.end = DateTime.fromJSDate(data.end).setZone(this.theEventData.timeZone).minus({hours: 12}).toJSDate()
      }
      this.modalEventProps.theEventData = this.theEventData
      this.modalEventProps.confirmText = 'event.add'
      this.showModalEditEvent = true
    }
  }

  async copyEvent(confirm: boolean){
    this.currentEvents = this.currentEvents.map((event) => {
      event.borderColor = ''
      event.groupId = ''
      return event
    })

    this.calendarApi.batchRendering(() => {
      this.calendarApi.removeAllEvents()
      this.calendarApi.addEventSource(this.currentEvents)
      this.calendarApi.addEventSource(this.iCalEvents)
    })

    if(confirm && this.copyEvents.length > 0){
      try{
        this.Loading = true
        this.$store.commit("setLoading",true)
        this.$set(this.confirmCopyEvent,'isLoading',true)
        const eventsColRef = this.$getEventsColRef()

        for (const event of this.copyEvents){
          console.log(event)
          const theEventDocData = this.$eventObjectToEventDocData(event)
          await this.$createDoc(eventsColRef,theEventDocData)
        }

        this.showModalCopyEvent = false
  
      }catch(error){
        console.log(error)
      }finally{
        this.$store.commit("setLoading",false);
        this.$set(this.confirmCopyEvent,'isLoading',false)
      }
    }else{
      this.showModalCopyEvent = false
    }
    this.copyEvents = []
  }

  sendMessege(){
    //
  }

  async editedEvent(data: false | EventData){
    if(data){
      try{
        this.$store.commit("setLoading",true)
        this.$set(this.modalEventProps,'isLoading',true)
        console.log('editEvent')
        console.log(data)
        this.rawEvents = this.rawEvents.map(rawEvent => {
          if(rawEvent.id === data.id){
            return data
          }
          return rawEvent
        })
        this.showModalEditEvent = false

      }catch(error){
        console.log(error)
        //const code = this.$getErrorCode(error)
        //const message = this.$getErrorMessageKey(code)
      }finally{
        this.$store.commit("setLoading",false);
      }
    }else{
        this.showModalEditEvent = false
    }
  }

  get lang(): string {
    return this.$store.getters.lang
  }

  @Watch('lang')
  changeLang(newVal: string){
    this.calendarOptions.locale = newVal
    this.showModalEditEvent = false
  }

  get queryEventDocId(){
    return this.$route.query.eventId as string
  }

  @Watch('queryEventDocId',{immediate: true})
  async changeQueryEventId(eventDocId: string){
    console.log('query eventid')
       if(typeof eventDocId === 'string'){
        this.theEventDocId = eventDocId

        try{
          this.showModalEventDetails = false

          const eventDoc = await getDoc(this.$getEventDocRef(this.theEventDocId))

          if(eventDoc.exists()){
            const event = eventDoc.data()
            event.timeZone = event.timeZone ? event.timeZone : this.timeZone 

            if(event){

              this.theEventData = {
                ...this.theEventData,
                ...event,
              }
              this.modalEventProps = {
                ...this.modalEventProps,
                theEventData: this.theEventData
              }
              this.showModalEventDetails = true
            }
          }else{
            this.showModalAlert = true
            this.alert = {
              title: this.$t('message.notFound') as string,
              message: this.$t('event.notFound') as string
            }
          }
          this.theEventDocId = ''
        }catch(error){
          this.showModalAlert = true
          this.alert = {
            title: this.$t('message.notAuthorized') as string,
            message: this.$t('event.notAuthorized') as string
          }
        }
      }
  }

  async created(){
    console.trace('created')
    try{
      this.timeZone = this.$defaultTimeZone
      if(this.$store.state.userPrivateProfile.iCalendarUrl){
        const getCalendar = httpsCallable(functions,'getCalendar')
        const config: GetCalendarArg = {
          schoolId: this.$store.getters.schoolId,
          range: {
            start: DateTime.now().minus({year: 1}).toJSDate(),
            end: DateTime.now().plus({year: 1}).toJSDate()
          }
        }
        const jcalData = await getCalendar(config) as {data: GetCalendarRes}
        //console.log(jcalData.data)
        this.iCalEvents = jcalData.data
        this.calendarApi.addEventSource(this.iCalEvents)
      }
    }catch(error){
          ///
    }
  }

  mounted(){
   //const api = (this.$refs.fullCalendar as any).getApi()
    
  }

  destroyed() {
    this.$unsubscriber(this.eventsObservers)
  }
}
